<div class="header" translate>UPLOADER_CONFIG_SMASH_TITLE</div>
<div class="content" *ngIf="drawerExpanded === true">
    <ng-scrollbar>
        <form class="inner-content" [formGroup]="parametersForm">
            <div class="parameter-row" *ngIf="isUpdateAvailabilityDurationActive">
                <div class="parameter-title">
                    <div class="label">
                        {{ 'UPLOADER_CONFIG_SMASH_SUBTITLE_VALIDITY_DURATION' | translate }}
                    </div>
                    <div class="parameter-error input-error" *ngIf="f.availabilityDuration.errors">
                        <span
                            *ngIf="f.availabilityDuration.value > transferSettings.availabilityDuration.max && (isPremium$ | async)"
                            translate
                            [translateParams]="{ count : transferSettings.availabilityDuration.max }">UPLOADER_CONFIG_SMASH_SUBTITLE_VALIDITY_DURATION_ERROR_PREMIUM_VAR</span>
                        <span
                            *ngIf="f.availabilityDuration.value > transferSettings.availabilityDuration.max && !(isPremium$ | async)"
                            translate
                            [translateParams]="{ count : transferSettings.availabilityDuration.max }">UPLOADER_CONFIG_SMASH_SUBTITLE_VALIDITY_DURATION_ERROR_FREEMIUM</span>
                    </div>
                </div>
                <div class="parameter-input availability-container">
                    <app-smash-input borderStyle="full" [error]="f.availabilityDuration.errors" type="number"
                        [max]="transferSettings.availabilityDuration.max" suffix="SUFFIX_DAYS"
                        formControlName="availabilityDuration">
                    </app-smash-input>
                </div>
            </div>
            <div class="parameter-row" *ngIf="isUpdatePasswordActive">
                <div class="parameter-title">
                    <div class="label">{{'UPLOADER_CONFIG_SMASH_SUBTITLE_PASSWORD' | translate}}</div>
                    <div class="parameter-error input-error" *ngIf="f.password.errors">
                        <span translate>UPLOADER_CONFIG_SMASH_SUBTITLE_PASSWORD_ERROR</span>
                    </div>
                </div>
                <div class="parameter-input password-container">
                    <app-smash-fake-password 
                        type="text" 
                        borderStyle="full" 
                        [error]="f.password.errors"
                        placeholder="{{'UPLOADER_CONFIG_SMASH_SUBTITLE_PASSWORD_PLACEHOLDER' | translate}}"
                        formControlName="password">
                    </app-smash-fake-password>
                </div>
            </div>
            <!-- only if email -->
            <div class="parameter-row" *ngIf="uploadFormMode === 'Email' && isDisplaySenderNotificationActive">
                <label>{{'UPLOADER_CONFIG_SMASH_SUBTITLE_SENDER_NOTIFICATION' | translate}}
                    <div class="parameter-input checkbox">
                        <app-smash-checkbox formControlName="senderNotification"></app-smash-checkbox>
                    </div>
                </label>
            </div>
            <!-- only if link -->
            <div class="parameter-row" *ngIf="uploadFormMode === 'Link' &&  isDisplayLinkNotificationActive">
                <label>{{'UPLOADER_CONFIG_SMASH_SUBTITLE_LINK_NOTIFICATION' | translate}}
                    <div class="parameter-input checkbox">
                        <app-smash-checkbox formControlName="linkNotification"></app-smash-checkbox>
                    </div>
                </label>
            </div>
            <div class="parameter-row" *ngIf="isDisplayDownloadNotificationActive">
                <label>{{'UPLOADER_CONFIG_SMASH_SUBTITLE_DOWNLOAD_NOTIFICATION' | translate}}
                    <div class="parameter-input checkbox">
                        <app-smash-checkbox formControlName="downloadNotification"></app-smash-checkbox>
                    </div>
                </label>
            </div>
            <div class="parameter-row" *ngIf="isDisplayNoDownloadNotificationActive">
                <label>{{'UPLOADER_CONFIG_SMASH_SUBTITLE_NO_DOWNLOAD_NOTIFICATION' | translate}}
                    <div class="parameter-input checkbox">
                        <app-smash-checkbox formControlName="noDownloadNotification"></app-smash-checkbox>
                    </div>
                </label>
            </div>
            <div class="parameter-row" *ngIf="isUpdatePreviewActive">
                <label>{{'UPLOADER_CONFIG_SMASH_SUBTITLE_PREVIEW' | translate}}
                    <div class="parameter-input checkbox">
                        <app-smash-checkbox formControlName="preview"></app-smash-checkbox>
                    </div>
                </label>
            </div>


            <div class="parameter-row" *ngIf="!(isPremium$ | async)">
                <label class="premium-feature"  [appSmashTooltip]="designFreemiumTooltip" [autoPlacement]="true" placement="right" contentType="template" offset="45" theme="light" width="200">
                    <div translate>UPLOADER_CONFIG_SMASH_SUBTITLE_DESIGN_FREEMIUM</div>
                    <div class="input-suffix input-icon icon-smash_lock"></div>
                </label>
            </div>

            <div class="parameter-row" *ngIf="!(isPremium$ | async)">
                <label class="premium-feature" [appSmashTooltip]="promotionFreemiumTooltip" [autoPlacement]="true" placement="right" contentType="template" offset="45" theme="light" width="200">
                    <div translate>UPLOADER_CONFIG_SMASH_SUBTITLE_PROMOTION_FREEMIUM</div>
                    <div class="input-suffix input-icon icon-smash_lock"></div>
                </label>
            </div>

            <div class="main-design-container" *ngIf="(isPremium$ | async) && (isUpdateCustomizationActive || isUpdatePromotionActive)">
                <div class="customization-container" *ngIf="isUpdateCustomizationActive && (customizationSelected || customizationLoading)">
                    <div class="design-title" translate>UPLOADER_CONFIG_SMASH_SUBTITLE_DESIGN_PREMIUM</div> 
                    <!-- hide on freemium -->
                    <div class="design-thumbnail" (click)="openModalCustomization()">
                        <app-smash-previewer-customization 
                            [customization]="customizationSelected"
                            [customizationLoading]="customizationLoading"
                            customizationAim="preview-customization-player-mini" displayType="miniScreen"
                            [url]="(domain$ | async)?.domain">
                        </app-smash-previewer-customization>
                        <div *ngIf="!!customizationSelected" class="design-edit-button-container">
                            <i class="design-edit-button icon-smash_edit"></i>
                        </div>
                    </div>
                </div>
                <div class="promotion-container" *ngIf="isUpdatePromotionActive && (promotionSelected || promotionLoading)">
                    <div class="design-title" translate>UPLOADER_CONFIG_SMASH_SUBTITLE_PROMOTION_PREMIUM</div>
                    <!-- hide on freemium -->
                    <div class="design-thumbnail" (click)="openModalPromotion()">
                        <app-smash-promotion class="promotion" 
                            [preview]="true" 
                            [replay]="false"
                            [promotion]="promotionSelected"
                            [promotionLoading]="promotionLoading">
                        </app-smash-promotion>
                        <div *ngIf="!!promotionSelected" class="design-edit-button-container">
                            <i class="design-edit-button icon-smash_edit"></i>
                        </div>
                    </div>
                </div>
            </div>           
        </form>
    </ng-scrollbar>
</div>

<ng-template #designFreemiumTooltip>
    <div class="tooltip-content">
        <div>{{'UPLOADER_CONFIG_SMASH_SUBTITLE_DESIGN_HELP' | translate}}</div>
    </div>
</ng-template>

<ng-template #promotionFreemiumTooltip>
    <div class="tooltip-content">
        <div>{{'UPLOADER_CONFIG_SMASH_SUBTITLE_PROMOTION_HELP' | translate}}</div>
    </div>
</ng-template>